<template>
  <form id="duracaoForm" @submit.prevent="submitDuracao()" class="ajax_off">
    <div class="form-group">
      <label
        >Previsão de termino do Projeto/Processo:
        <i
          class="fas fa-info-circle"
          v-b-tooltip.hover.top
          title="(Campo opcional para acompanhamento de relatórios) Informe o prazo de finalização total do Projeto/Processo."
        ></i
      ></label>
      <div class="input-group mb-3">
        <input
          name="duracao"
          placeholder="opcional"
          class="form-control"
          type="number"
          v-model="tarefa.duracao"
        />
        <div class="input-group-append">
          <span class="input-group-text">Dias</span>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label>Contar a partir de:</label>
      <input
        type="date"
        name="date_start"
        class="form-control"
        :value="
          tarefa.date_start != null
            ? moment(tarefa.date_start).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD')
        "
        @change="tarefa.date_start = $event.target.value"
      />
    </div>

    <b-button
      type="button"
      v-if="tarefa.tempo_decorrido != null && tarefa.duracao > 0"
      variant="outline-secondary"
      @click.prevent="finalizarProjetoProcesso()"
    >
      Finalizar Projeto/Processo
    </b-button>
  </form>
</template>

<script>
export default {
  data() {
    return {
      tarefa: {},
    };
  },
  props: {
    cartao: Object,
  },
  created() {
    this.tarefa = this.cartao;
  },
  methods: {
    async submitDuracao() {
      let { tarefa_id, titulo, data_entrega, descricao, duracao, date_start } =
        this.tarefa;

      const result = await this.$api.put(`tarefa/${tarefa_id}`, {
        titulo,
        data_entrega,
        descricao,
        duracao,
        date_start,
      });

      this.$emit("getCartao");
      this.$bvModal.hide("duracao");
    },
    finalizarProjetoProcesso() {
      this.$swal({
        title: "Tem certeza?",
        text: this.cartao.tabela_id
          ? "O processo linkado a tarefa também será arquivado!"
          : "O projeto será finalizado!",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Sim, Finalizar",
        denyButtonText: `Agora não`,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$api
            .put("tarefa/finalizarProjetoOuProcesso", {
              tarefa_id: this.cartao.tarefa_id,
            })
            .then((result) => {
              this.$swal.fire(
                "Projeto/Processo finalizado com sucesso!",
                "",
                "success"
              );
              this.$emit("updateCartao");
              this.$bvModal.hide("duracao");
            });
        }
        //this.$swal.fire("Saved!", "", "success");
      });
    },
  },
};
</script>